const getInitials = (name = "") => {
  if (name.trim() === "") return null

  const initials = name.split(" ").length === 1 ? name.slice(0, 2) : name.split(" ").map(n => n[0])

  return initials.length === 1 ? initials.toUpperCase() : `${initials[0]}${initials[initials.length - 1]}`.toUpperCase()
}

export default getInitials;
